/** @flow */
import React from 'react';
import Radio from 'common/domain/radio';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';

import type { ListeningTimeState } from './domain/State';
import { parseListeningTimeState } from './domain/State';
import ListeningTimePrinting from './printing/ListeningTimePrinting';

type State = {
  listeningTime: ListeningTimeState;
  loading: boolean;
  radio: Radio;
}

class ListeningTimePrintingPage extends React.Component<any, State> {
  constructor(props: any) {
    super(props);

    const data = PrintingService.getData('LISTENING_TIME_PRINTING_DATA');
    if (!data) {
      return;
    }

    this.state = {
      loading: false,
      listeningTime: parseListeningTimeState(data.listeningTime),
      radio: data.radio,
    };
    setTimeout(() => window.print(), 1000);
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { listeningTime, radio, loading } = this.state;
    return (
      <PrintingPage loading={loading}>
        {listeningTime &&
          <ListeningTimePrinting listeningTime={listeningTime} radio={radio} />
        }
      </PrintingPage>
    );
  }
}

export default ListeningTimePrintingPage;



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/ListeningTimePrintingPage.js